export default class AppearancesMerger {

	// Public:
	compute(appearances) {
		this._results = []
		let accum = null
		appearances.sort(a => a['start'])
		appearances.forEach(appearance => {
			if (accum !== null) {
				if ((appearance?.text.includes(accum?.text) || accum?.text.includes(appearance?.text)) && this._doAppearancesOverlap(appearance, accum)) {
					accum = this._merge(appearance, accum)
				} else {
					this._formatAndAddAppearance(accum)
					accum = appearance
				}
			} else {
				accum = appearance
			}
		});
		if (accum !== null) {
			this._formatAndAddAppearance(accum)
		}
		return this._results
	}

	// Private:
	_merge(a, a0) {
		const start = [a.start, a0.start].sort()[0]
		const end = [a.end, a0.end].sort().reverse()[0]
		let merged = a
		merged['start'] = start
		merged['end'] = end
		const duration = this._computeDuration(merged)
		merged['duration'] = duration
		return merged
	}

	_formatAndAddAppearance(a) {
		const dt = this._computeDuration(a)
		a['duration'] = dt
		if (dt > 0) {
			this._addAppearance(a)
		}
	}

	_addAppearance(a) {
		this._results.push(a)
	}

	_doAppearancesOverlap(a1, a2) {
		const end1 = a1.end
		const start1 = a1.start
		const end2 = a2.end
		const start2 = a2.start
		if (start1 && end1 && start2 && end2) {
			return (end1 >= start2) && (end2 >= start1)
		} else if (!end1 && !end2) {
			return start1 === start2
		} else if (!end1) {
			return (start1 >= start2) && (start1 <= end2)
		} else if (!end2) {
			return (start2 >= start1) && (start2 <= end1)
		} else {
			return false
		}
	}

	_computeDuration(a) {
		try {
			const start = a.start
			const end = a.end
			const t0 = this._timemstampToSeconds(start)
			const t1 = this._timemstampToSeconds(end)
			const dt = t1 - t0
		return dt
		} catch {
			return 0
		}
	}

	_timemstampToSeconds(s) {
		s = s.replaceAll(',', '.')
		const parts = s.split(":")
		const hours = parseInt(parts[0])
		const mins = parseInt(parts[1])
		const secs = parseFloat(parts[2])
		const seconds = hours * 3600 + mins * 60 + secs
		return seconds
	}

}